/**
 * Live total for onsite training days / attendees, and pass those counts
 * through WooCommerce Store API add-to-cart.
 */

function parseConfig(root) {
	try {
		return JSON.parse(root.getAttribute('data-onsite-training') || '');
	} catch (error) {
		return null;
	}
}

function fieldValue(root, name, fallback) {
	const input = root.querySelector(`[name="${name}"]`);
	if (!(input instanceof HTMLInputElement)) {
		return fallback;
	}

	const value = parseInt(input.value, 10);
	return Number.isFinite(value) ? value : fallback;
}

function clampInput(input, min) {
	if (!(input instanceof HTMLInputElement)) {
		return;
	}

	const value = parseInt(input.value, 10);
	if (!Number.isFinite(value) || value < min) {
		input.value = String(min);
	}
}

function calculate(config, days, people) {
	let total = config.base;
	if (config.usesDays) {
		const billedDays = config.chargeAllDays
			? Math.max(config.minDays, days)
			: Math.max(0, days - config.minDays);
		total += config.dayRate * billedDays;
	}
	if (config.usesPeople) {
		if (config.peopleOverMin) {
			if (people > config.minPeople) {
				total += config.personRate * people;
			}
		} else {
			const billedPeople = config.chargeAllPeople
				? Math.max(config.minPeople, people)
				: Math.max(0, people - config.minPeople);
			total += config.personRate * billedPeople;
		}
	}
	return total;
}

function formatMoney(amount) {
	try {
		return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
		}).format(amount);
	} catch (error) {
		return `$${amount.toFixed(2)}`;
	}
}

function updateTotal(root, config) {
	const days = fieldValue(root, 'aaet_onsite_days', config.minDays);
	const people = fieldValue(root, 'aaet_onsite_people', config.minPeople);
	const total = calculate(config, days, people);
	const target = root.querySelector('[data-onsite-total]');
	if (target) {
		target.textContent = formatMoney(total);
	}
}

function bindRoot(root) {
	const config = parseConfig(root);
	if (!config) {
		return;
	}

	root.querySelectorAll('.onsite-training__input').forEach((input) => {
		input.addEventListener('input', () => {
			const min = input.name === 'aaet_onsite_days' ? config.minDays : config.minPeople;
			clampInput(input, min);
			updateTotal(root, config);
		});
	});

	root.querySelectorAll('[data-onsite-step]').forEach((button) => {
		button.addEventListener('click', () => {
			const wrap = button.closest('.onsite-training__field');
			const input = wrap?.querySelector('.onsite-training__input');
			if (!(input instanceof HTMLInputElement)) {
				return;
			}

			const min = input.name === 'aaet_onsite_days' ? config.minDays : config.minPeople;
			const next = (parseInt(input.value, 10) || min) + Number(button.getAttribute('data-onsite-step'));
			input.value = String(Math.max(min, next));
			updateTotal(root, config);
		});
	});

	updateTotal(root, config);
}

function patchStoreApi() {
	if (window.aaetOnsiteFetchPatched || typeof window.fetch !== 'function') {
		return;
	}

	window.aaetOnsiteFetchPatched = true;
	const original = window.fetch.bind(window);

	window.fetch = (input, init = {}) => {
		const url = typeof input === 'string' ? input : input?.url;
		if (!url || !url.includes('/wc/store') || !url.includes('add-item')) {
			return original(input, init);
		}

		const root = document.querySelector('[data-onsite-training]');
		if (!root) {
			return original(input, init);
		}

		const config = parseConfig(root);
		const body = init.body;
		if (!config || typeof body !== 'string') {
			return original(input, init);
		}

		try {
			const payload = JSON.parse(body);
			if (config.usesDays) {
				payload.aaet_onsite_days = fieldValue(root, 'aaet_onsite_days', config.minDays);
			}
			if (config.usesPeople) {
				payload.aaet_onsite_people = fieldValue(root, 'aaet_onsite_people', config.minPeople);
			}
			payload.quantity = 1;
			init = { ...init, body: JSON.stringify(payload) };
		} catch (error) {
			return original(input, init);
		}

		return original(input, init);
	};
}

document.querySelectorAll('[data-onsite-training]').forEach(bindRoot);
patchStoreApi();
